import React, { useEffect, useRef } from 'react';

export const Item = ({
  closeDDM,
  closeOnBlurDDM,
  item,
  itemsSize,
  checked,
  focus,
  positionIndex,
  setFocusPosition,
  parentPositionIndex,
  parentItemsSize,
  onSelect,
  focusedItem,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (focusedItem) {
      ref.current.focus();
    }
  }, [focus.focusInnerIndex, focus.focusIndex, focusedItem]);

  const moveFocusUp = () => {
    focus.focusInnerIndex = focus.focusInnerIndex - 1;
  };

  const moveFocusDown = () => {
    if (itemsSize === focus.focusInnerIndex + 1) {
      focus.focusIndex = focus.focusIndex + 1;
      focus.focusInnerIndex = -1;
    } else {
      focus.focusInnerIndex = focus.focusInnerIndex + 1;
    }

    setFocusPosition(focus);
  };

  const handleOnKeyDown = (item, e) => {
    const { key } = e;
    if (key === 'ArrowUp') {
      moveFocusUp();
    } else if (key === 'ArrowDown') {
      const lastItemPosition = focus.focusInnerIndex === itemsSize - 1 && focus.focusIndex === parentItemsSize - 1;
      if (!lastItemPosition) {
        moveFocusDown();
      }
    } else if (key === 'Enter' || key === ' ') {
      onSelect(item);
    } else if (key === 'Escape') {
      closeDDM();
    } else if (key === 'ArrowLeft') {
      focus.focusInnerIndex = -1;
    }

    setFocusPosition(focus);
  };

  return (
    <li
      key={item.id}
      value={item.id}
      className={`${focusedItem ? 'crl-focus' : ''} crl-element ${checked ? 'crl-selected' : ''}`}
      tabIndex={focus.focusInnerIndex === positionIndex && parentPositionIndex === focus.focusIndex ? '0' : '-1'}
      onClick={onSelect.bind(null, item)}
      onBlur={closeOnBlurDDM}
      onKeyDown={handleOnKeyDown.bind(this, item)}
      ref={ref}
      role={'menuitemradio'}
      aria-checked={checked}>
      <span className="checkBox-icon">{checked ? <i className="checkBox far"></i> : void 0}</span>
      <span className="checkBox-title">{item.name}</span>
    </li>
  );
};

export default Item;
